// Configuration centralisée du module de diagnostic
const CONFIG = {
    // Informations de la boutique
    shop: {
        name: "The Ralica",
        domain: "theralica.myshopify.com",
        currency: "EUR",
        currencySymbol: "€"
    },

    // Paramètres d'affichage
    display: {
        maxRecommendations: 3,
        showPrices: true,
        showImages: true,
        showBenefits: true,
        animationsEnabled: true
    },

    // Textes personnalisables
    texts: {
        mainTitle: "🌿 Diagnostic Personnalisé",
        mainSubtitle: "Découvrez les produits adaptés à vos besoins",
        selectionTitle: "Choisissez votre diagnostic personnalisé",
        resultsTitle: "✨ Votre programme personnalisé",
        resultsSubtitle: "Basé sur vos réponses, voici nos recommandations",
        profileTitle: "📋 Votre profil",
        addToCartButton: "Ajouter au panier",
        restartButton: "🔄 Refaire le diagnostic",
        nextButton: "Suivant →",
        previousButton: "← Précédent",
        addToCartSuccess: "✅ Produit ajouté au panier !",
        addToCartError: "❌ Erreur lors de l'ajout au panier",
        priorityLabels: [
            "🥇 Recommandé en priorité",
            "🥈 Complément idéal", 
            "🥉 Pour aller plus loin"
        ]
    },

    // Couleurs du thème (peut être synchronisé avec votre thème Shopify)
    colors: {
        primary: "#2d5f4c",
        secondary: "#7ba888",
        accent: "#d4a574",
        textDark: "#2c3e50",
        textLight: "#6c757d",
        bgLight: "#f8f9fa",
        white: "#ffffff"
    },

    // Paramètres Analytics
    analytics: {
        googleAnalyticsEnabled: false,
        googleAnalyticsId: "UA-XXXXXXXXX-X",
        facebookPixelEnabled: false,
        facebookPixelId: "XXXXXXXXXXXXXXXXX",
        trackDiagnosticStart: true,
        trackDiagnosticComplete: true,
        trackAddToCart: true
    },

    // Paramètres de panier
    cart: {
        // Méthodes disponibles : 'ajax', 'redirect', 'sdk'
        addToCartMethod: 'ajax',
        
        // Redirection après ajout au panier
        redirectAfterAdd: false,
        redirectUrl: '/cart',
        
        // Quantité par défaut
        defaultQuantity: 1,
        
        // Afficher une notification après ajout
        showNotification: true,
        notificationDuration: 3000
    },

    // Règles de recommandation avancées
    recommendationRules: {
        // Priorités par problématique
        priorities: {
            digestion: {
                ballonnements: ["Probiotiques 10M", "Probiotiques 3M", "Draineur Universel"],
                constipation: ["Transit", "Probiotiques 10M", "Draineur Universel"],
                digestionLourde: ["DETOX", "Draineur Universel", "Probiotiques 10M"],
                microbiote: ["Probiotiques 10M", "Probiotiques 3M", "Transit"]
            },
            vitalite: ["Vitality Complex", "Magnésium", "Vitamine D3"],
            stress: ["Magnésium", "Ashwagandha", "Mélatonine"],
            minceur: ["Chrome Cannelle", "Draineur Universel", "Thé Vert"],
            peau: ["Collagène", "Biotine", "Zinc"],
            circulation: ["Vigne Rouge", "Curcuma", "Oméga-3"]
        },
        
        // Produits complémentaires
        complementaryProducts: {
            "Probiotiques 10M": ["Transit", "DETOX"],
            "Magnésium": ["Ashwagandha", "Mélatonine"],
            "Chrome Cannelle": ["Draineur Universel", "Thé Vert"]
        },
        
        // Remplacements si produit en rupture
        alternatives: {
            "Probiotiques 10M": "Probiotiques 3M",
            "Transit": "Draineur Universel"
        }
    },

    // SEO et Meta
    seo: {
        pageTitle: "Diagnostic Personnalisé - Trouvez vos produits idéaux",
        metaDescription: "Répondez à quelques questions pour découvrir les compléments alimentaires parfaitement adaptés à vos besoins.",
        ogImage: "/assets/diagnostic-og-image.jpg"
    },

    // Email marketing (optionnel)
    emailMarketing: {
        enabled: false,
        provider: 'klaviyo', // ou 'mailchimp', 'sendinblue'
        listId: '',
        collectEmailAfterDiagnostic: false
    },

    // Modes de développement
    dev: {
        debugMode: false,
        showConsoleLog: false,
        testMode: false
    }
};

// Fonction d'initialisation des analytics
function initAnalytics() {
    if (CONFIG.dev.debugMode && CONFIG.dev.showConsoleLog) {
        console.log('🔧 Mode debug activé');
    }
}

// Fonction de tracking des événements
function trackEvent(eventName, eventData = {}) {
    if (CONFIG.dev.debugMode && CONFIG.dev.showConsoleLog) {
        console.log('📊 Event:', eventName, eventData);
    }

    // Google Analytics
    if (CONFIG.analytics.googleAnalyticsEnabled && typeof gtag !== 'undefined') {
        gtag('event', eventName, eventData);
    }

    // Facebook Pixel
    if (CONFIG.analytics.facebookPixelEnabled && typeof fbq !== 'undefined') {
        fbq('trackCustom', eventName, eventData);
    }
}

// Export de la configuration (si vous utilisez des modules ES6)
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { CONFIG, trackEvent, initAnalytics };
}
